import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


let desc = '';
let lugarCentral = '';
let vinculacion = '';
let cargo = '';
let grado = '';
let escalafon = '';
let codRelLab = '';
let codForPago = '';
let serieConcurso = '';

class CambiosFuncionario extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            errores: null,
            notificaciones: null,
            consulta: false,
            checkAdd: false,
            consultaEsp: false,
            modalFinalizar: false,

            busqueda:{
                numeroFuncionario: '',
            },

            hastaFinalizar: '',

            ingreso: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                cargo: '',
                grado: '',
                lugar: '',
                lugarCentral: '',
                escalafon: '',
                vinculacion: '',
                cargaHorariaHora: '',
                cargaHorariaMinuto: '',
                desde: '',
                hasta: '',
                codigoRelLaboral: '',
                codigoForPago: '',
                serieConcurso: '',
            },

            datosObtenidos: {},
            datosCambios: [],
            consultaDatos: {},

            numeroNombre: [],
            cargos: [],
            ubicacionesCentral: [],
            lugaresTrabajo: [],
            escalafones: [],
            vinculacion: [],
            codRelaLaboral: [],
            codFormaPago: [],
            serieBase: [],
        }

        this.manejarCambioNumFun = this.manejarCambioNumFun.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioCambio = this.manejarEnvioCambio.bind(this);
        this.actualizarDatos = this.actualizarDatos.bind(this);
        this.cambioAgregar = this.cambioAgregar.bind(this);
        this.manejarConsulta = this.manejarConsulta.bind(this);
        this.manejarFinalizar = this.manejarFinalizar.bind(this);
        this.manejarVolver = this.manejarVolver.bind(this);
        this.manejarVolverConsulta = this.manejarVolverConsulta.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarCambiosDatosFinalizar = this.manejarCambiosDatosFinalizar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarEnvioFinalizar = this.manejarEnvioFinalizar.bind(this);
        this.actualizarLista = this.actualizarLista.bind(this);
    }

    async componentDidMount(){

        const pago = await fetch(`${Constantes.RUTA_API}/obtener_formasPago.php`);
        const datPago = await pago.json();
        this.setState({
            codFormaPago: datPago,
        });

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_codigosRelLab.php`);
        const datos = await respuesta.json();
        this.setState({
            codRelaLaboral: datos,
        });

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const datosCargos = await fetch(`${Constantes.RUTA_API}/obtener_cargos.php`);
        const datoCargo = await datosCargos.json();
        this.setState({
            cargos: datoCargo,
        });

        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTrabajo: datoLugar,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

        const vin = await fetch(`${Constantes.RUTA_API}/obtener_vinculaciones.php`);
        const dat = await vin.json();
        this.setState({
            vinculacion: dat,
        });

        const serie = await fetch(`${Constantes.RUTA_API}/obtener_series.php`);
        const datoSerie = await serie.json();
        this.setState({
            serieBase: datoSerie,
        });
    }
    
    render(){
        return (
            <>
                <Container>
                    <h3>Cambios Funcionarios</h3>
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.consulta
                    ?
                        null
                    :
                        <form className='formulario1'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.5}>

                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Número de Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambioNumFun} type="text" />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    }
                    {this.state.consulta  && !this.state.consultaEsp
                    ?
                        <FormControlLabel label='Agregar Cambio' control={<Checkbox checked={this.state.checkAdd} onChange={this.cambioAgregar} id='add'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    :
                        null
                    }
                    {(this.state.consulta && this.state.checkAdd)
                    ?
                        <Container>
                            <form className='formulario' onSubmit={this.manejarEnvioCambio}>
                                <fieldset>
                                    <legend>DATOS FUNCIONARIO</legend>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2.14}>
                                                Código Relación Laboral <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoRelLaboral' value={this.state.ingreso.codigoRelLaboral} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}></option>
                                                    {this.state.codRelaLaboral.map((name) =>
                                                    <option
                                                    key={name.idCodigoRelacionLaboral}
                                                    value={name.idCodigoRelacionLaboral}
                                                    >{name.descripcion}</option>
                                                    )}
                                                    </select>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Código Forma De Pago <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoForPago' value={this.state.ingreso.codigoForPago} onChange={this.manejarCambiosDatos}>
                                                <option value={''}></option>
                                                    {this.state.codFormaPago.map((name) =>
                                                    <option
                                                    key={name.idCodigoFormaPago}
                                                    value={name.idCodigoFormaPago}
                                                    >{name.descripcion}</option>
                                                    )}
                                                    </select>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Cargo <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='cargo'  value={this.state.ingreso.cargo} onChange={this.manejarCambiosDatos}>
                                                    <option value=''></option>
                                                    {this.state.cargos.map((name) =>
                                                        <option
                                                        key={name.idCargo}
                                                        value={name.idCargo}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Escalafón <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.ingreso.escalafon} onChange={this.manejarCambiosDatos}>
                                                        <option value=''></option>
                                                        {this.state.escalafones.map((name) =>
                                                            <option
                                                            key={name.idEscalafon}
                                                            value={name.idEscalafon}
                                                            >{name.descripcion}</option>
                                                            )}
                                                    </select>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Grado <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='grado' value={this.state.ingreso.grado} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}></option>
                                                    <option value={1}>1</option>
                                                    <option value={2}>2</option>
                                                    <option value={3}>3</option>
                                                    <option value={4}>4</option>
                                                    <option value={5}>5</option>
                                                    <option value={6}>6</option>
                                                    <option value={7}>7</option>
                                                    <option value={8}>8</option>
                                                    <option value={9}>9</option>
                                                    <option value={10}>10</option>
                                                    <option value={11}>11</option>
                                                    <option value={12}>12</option>
                                                    <option value={13}>13</option>
                                                    <option value={14}>14</option>
                                                    <option value={15}>15</option>
                                                    <option value={16}>16</option>
                                                    </select>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Serie Concurso<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='serieConcurso' value={this.state.ingreso.serieConcurso} onChange={this.manejarCambiosDatos} >
                                                    <option value={''}></option>
                                                    {this.state.serieBase.map((name) =>
                                                        <option
                                                        key={name.idSerie}
                                                        value={name.idSerie}
                                                        >{name.descripcion}</option>
                                                    )}
                                                </select>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Carga Horaria <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{width:"50%", border:"2px solid #D6EAF8", float:"left"}} type="number" id='cargaHorariaHora' placeholder='HORAS' value={this.state.ingreso.cargaHorariaHora} onChange={this.manejarCambiosDatos}/>
                                                <input style={{width:"50%", border:"2px solid #D6EAF8"}} type="number" placeholder='MINUTOS' id='cargaHorariaMinuto' value={this.state.ingreso.cargaHorariaMinuto} onChange={this.manejarCambiosDatos}/>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Lugar <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugar" value={this.state.ingreso.lugar} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}></option>
                                                    {this.state.lugaresTrabajo.map((name) =>
                                                        <option
                                                        key={name.idLugaresTrabajo}
                                                        value={name.idLugaresTrabajo}
                                                        >{name.lugar}</option>
                                                        )}
                                                </select>
                                            </Grid>
                                            {this.state.ingreso.lugar == '0' ?
                                                <Grid item xs={2.1} >
                                                    Lugar CENTRAL<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.ingreso.lugar == '0' ?
                                                <Grid item xs={3}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugarCentral" value={this.state.ingreso.lugarCentral} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}></option>
                                                        {this.state.ubicacionesCentral.map((name) =>
                                                            <option
                                                            key={name.idUbicacionesCentral}
                                                            value={name.idUbicacionesCentral}
                                                            >{name.descripcion}</option>
                                                            )}
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            <Grid item xs={2.1}>
                                                Vinculación<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='vinculacion' value={this.state.ingreso.vinculacion} onChange={this.manejarCambiosDatos} >
                                                    <option value={''}></option>
                                                    {this.state.vinculacion.map((name) =>
                                                        <option
                                                        key={name.idVinculacion}
                                                        value={name.idVinculacion}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Desde<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8", float:"left"}} type="date" id='desde'  value={this.state.ingreso.desde} onChange={this.manejarCambiosDatos}/>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Hasta
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8", float:"left"}} type="date" id='hasta'  value={this.state.ingreso.hasta} onChange={this.manejarCambiosDatos}/>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                                <button type="submit" className="btn btn-outline-primary"> Confirmar</button>
                            </form>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    {this.state.consulta && !this.state.consultaEsp
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número</StyledTableCell>
                                            <StyledTableCell>Nombre</StyledTableCell>
                                            <StyledTableCell>Desde</StyledTableCell>
                                            <StyledTableCell>Hasta</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosCambios.map((dato,index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.desde}</StyledTableCell>
                                                <StyledTableCell>{dato.hasta}</StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsulta(dato)}>Consultar</button></StyledTableCell>
                                                {dato.hasta === 'ACTIVO' ? <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarFinalizar(dato)}>Finalizar</button></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                                <StyledTableCell><button type="button" className="btn btn-outline-danger mx-2" onClick={() => this.manejarBorrar(dato)}>Borrar</button></StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <br/>
                            <button type="button" className="btn btn-outline-primary mx-2" onClick={this.manejarVolverConsulta}> Atras</button>
                        </Container>
                    :
                        null
                    }
                    {this.state.consultaEsp
                    ?
                        <Container>
                            <form className='formulario'>
                                <fieldset>
                                    <legend>DATOS FUNCIONARIO</legend>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2.14}>
                                                Código Relación Laboral <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.codRelaLaboral.map((name) => {
                                                    if(name.idCodigoRelacionLaboral === this.state.consultaDatos.codigoRelLaboral){
                                                        codRelLab = name.descripcion;
                                                    }
                                                })}
                                                {codRelLab}
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Código Forma De Pago <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.codFormaPago.map((name) => {
                                                    if(name.idCodigoFormaPago === this.state.consultaDatos.codigoForPago){
                                                        codRelLab = name.descripcion;
                                                    }
                                                })}
                                                {codRelLab}
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Cargo <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.cargos.map((name) => {
                                                    if(name.idCargo === this.state.consultaDatos.cargo){
                                                        cargo = name.descripcion;
                                                    }
                                                })}
                                                {cargo}
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Escalafón <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.escalafones.map((name) => {
                                                    if(name.idEscalafon === this.state.consultaDatos.escalafon){
                                                        escalafon = name.descripcion;
                                                    }
                                                })}
                                                {escalafon}
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Grado <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.consultaDatos.grado}
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Serie Concurso<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.serieBase.map((name) => {
                                                    if(name.idSerie === this.state.consultaDatos.serieConcurso){
                                                        serieConcurso = name.descripcion;
                                                    }
                                                })}
                                                {serieConcurso}
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Carga Horaria <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.consultaDatos.cargaHorariaHora}
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Lugar <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.lugaresTrabajo.map((name) => {
                                                    if(name.idLugaresTrabajo === this.state.consultaDatos.lugar){
                                                        desc = name.lugar;
                                                    }
                                                })}
                                                {desc}
                                            </Grid>
                                            {this.state.consultaDatos.lugar == '0' ?
                                                <Grid item xs={2.1} >
                                                    Lugar CENTRAL<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.consultaDatos.lugar == '0' ?
                                                <Grid item xs={3}>
                                                    {this.state.ubicacionesCentral.map((name) => {
                                                        if(name.idUbicacionesCentral === this.state.consultaDatos.lugarCentral){
                                                            lugarCentral = name.descripcion;
                                                        }
                                                    })}
                                                    {lugarCentral}
                                                </Grid>
                                            :
                                                null
                                            }
                                            <Grid item xs={2.1}>
                                                Vinculación<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.vinculacion.map((name) => {
                                                    if(name.idVinculacion === this.state.consultaDatos.vinculacion){
                                                        vinculacion = name.descripcion;
                                                    }
                                                })}
                                                {vinculacion}
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Desde<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.consultaDatos.desde}
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                Hasta
                                            </Grid>
                                            <Grid item xs={3}>
                                                {this.state.consultaDatos.hasta}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                            </form>
                            <button type="button" className="btn btn-outline-primary mx-2" onClick={this.manejarVolver}> Atras</button>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    <Modal open={this.state.modalFinalizar}>
                        <form className='formulario1'>
                            <Box sx={styleModal}>
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={4}>
                                        <Item>
                                            Fecha Hasta
                                        </Item>
                                    </Grid>
                                    <Grid item xs={4}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{border:"2px solid #D6EAF8", float:"left"}} type="date" id='hastaFinalizar'  value={this.state.hastaFinalizar} onChange={this.manejarCambiosDatosFinalizar}/>
                                    </Grid>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioFinalizar}>Confirmar</button>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Modal>
                </Container>
            </>
        )
    }

    actualizarDatos(e){
        this.setState(state => {
            const funcionarioActualizado = state.ingreso;
            funcionarioActualizado['numeroFuncionario'] = state.datosObtenidos.numeroFuncionario;
            funcionarioActualizado['nombreFuncionario'] = state.datosObtenidos.primerNombre + ' ' +  state.datosObtenidos.primerApellido;
            funcionarioActualizado['cargo'] = state.datosObtenidos.cargo;
            funcionarioActualizado['grado'] = state.datosObtenidos.grado;
            funcionarioActualizado['lugar'] = state.datosObtenidos.lugar;
            funcionarioActualizado['lugarCentral'] = state.datosObtenidos.lugarCentral;
            funcionarioActualizado['escalafon'] = state.datosObtenidos.escalafon;
            funcionarioActualizado['vinculacion'] = state.datosObtenidos.vinculacion;
            funcionarioActualizado['cargaHorariaHora'] = state.datosObtenidos.cargaHorariaHora;
            funcionarioActualizado['cargaHorariaMinuto'] = state.datosObtenidos.cargaHorariaMinuto;
            funcionarioActualizado['desde'] = '';
            funcionarioActualizado['hasta'] = '';
            funcionarioActualizado['codigoRelLaboral'] = state.datosObtenidos.codigoRelLaboral;
            funcionarioActualizado['codigoForPago'] = state.datosObtenidos.codigoForPago;
            funcionarioActualizado['serieConcurso'] = state.datosObtenidos.serieConcurso;
            return{
                ingreso: funcionarioActualizado,
            }
        });
    }

    manejarCambioNumFun(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            consulta: false,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.busqueda;
            funcionarioActualizado[clave] = valor;
            return{
                busqueda: funcionarioActualizado,
            };
        })
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
        })
        if(this.state.busqueda.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar el número de funcionario',
                notificaciones: null,
            })
        }else{
            this.setState({
                errores: null,
                loading: true,
            })
            const cargaUtil = JSON.stringify(this.state.busqueda);
            const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_NumFun.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            //Consulto sobre los movimientos que ya tuvo
            const cargaUtil2 = JSON.stringify([this.state.busqueda]);
            const res = await fetch(`${Constantes.RUTA_API}/consultar_cambiosCargos.php`,{
                method: 'POST',
                body: cargaUtil2,
            })
            const exito2 = await res.json();
            //------------------------------------------
            if(exito){
                if(exito.length === 0){
                    this.setState({
                        errores: 'NO EXISTEN DATOS PARA EL NUMERO DE FUNCIONARIO INGRESADO',
                        loading: false,
                        notificaciones: null,
                    });
                }else{
                    this.setState({
                        datosObtenidos: exito[0],
                        datosCambios: exito2[1],
                        loading: false,
                        errores: null,
                        notificaciones: null,
                        consulta: true,
                    });
                    this.actualizarDatos();
                }
            }
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;

        this.setState({
            errores: null,
            notificaciones: null,
        })

        this.setState(state => {
            const movimientosActualizado = state.ingreso;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    movimientosActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    movimientosActualizado['nombreFuncionario'] = '';
                }
                });
            }
            movimientosActualizado[clave] = valor;
            return{
                ingreso: movimientosActualizado,
            };
        })
    }

    async manejarEnvioCambio(e){
        e.preventDefault();
        if(this.state.ingreso.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar el número de funcionario',
            })
        }else if((this.state.ingreso.numeroFuncionario !== '') && (this.state.ingreso.nombreFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar el número de funcionario valido',
            })
        }else if((this.state.ingreso.cargo === '')){
            this.setState({
                errores: 'Debe ingresar el cargo',
            })
        }else if((this.state.ingreso.grado === '')){
            this.setState({
                errores: 'Debe ingresar el grado',
            })
        }else if((this.state.ingreso.lugar === '')){
            this.setState({
                errores: 'Debe ingresar el lugar de trabajo',
            })
        }else if((this.state.ingreso.lugarCentral === '')){
            this.setState({
                errores: 'Debe ingresar el departamento',
            })
        }else if((this.state.ingreso.escalafon === '')){
            this.setState({
                errores: 'Debe ingresar el escalafon',
            })
        }else if((this.state.ingreso.vinculacion === '')){
            this.setState({
                errores: 'Debe ingresar le vinculación',
            })
        }else if((this.state.ingreso.cargaHorariaHora === '')){
            this.setState({
                errores: 'Debe ingresar la carga horaria',
            })
        }else if((this.state.ingreso.cargaHorariaMinuto === '')){
            this.setState({
                errores: 'Debe ingresar la carga horaria',
            })
        }else if((this.state.ingreso.codigoRelLaboral === '')){
            this.setState({
                errores: 'Debe ingresar la relación lavoral',
            })
        }else if((this.state.ingreso.codigoForPago === '')){
            this.setState({
                errores: 'Debe ingresar la forma de pago',
            })
        }else if((this.state.ingreso.serieConcurso === '')){
            this.setState({
                errores: 'Debe ingresar la serie',
            })
        }else if((this.state.ingreso.desde === '')){
            this.setState({
                errores: 'Debe ingresar la fecha desde',
            })
        }else{
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.ingreso]);
            //Voy a probar hacer los controles en la logica

            const control = await fetch(`${Constantes.RUTA_API}/guardar_cambioCargo.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
            });

            if(res[0] === 'ok'){
                this.setState({
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    errores: null,
                    loading: false,
                    consulta: false,
                    checkAdd: false,
                    ingreso: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        cargo: '',
                        grado: '',
                        lugar: '',
                        lugarCentral: '',
                        escalafon: '',
                        vinculacion: '',
                        cargaHorariaHora: '',
                        cargaHorariaMinuto: '',
                        desde: '',
                        hasta: '',
                        codigoRelLaboral: '',
                        codigoForPago: '',
                        serieConcurso: '',
                    },
                })
            }
        }
    }

    cambioAgregar(e){
        if(this.state.checkAdd){
            this.setState({
                checkAdd: false,
            })
        }else{
            this.setState({
                checkAdd: true,
            })
        }
    }

    manejarConsulta(dato){
        this.setState({
            consultaEsp: true,
            consultaDatos: dato,  
        })
    }

    manejarFinalizar(dato){
        this.setState({
            consultaDatos: dato,
            modalFinalizar: true,
        })
    }

    manejarVolver(e){
        e.preventDefault();
        this.setState({
            consultaEsp: false,
            consultaDatos: {},
        })
    }

    manejarVolverConsulta(e){
        e.preventDefault();
        this.setState({
            loading: false,
            errores: null,
            notificaciones: null,
            consulta: false,
            checkAdd: false,
            consultaEsp: false,

            busqueda:{
                numeroFuncionario: '',
            },

            ingreso: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                cargo: '',
                grado: '',
                lugar: '',
                lugarCentral: '',
                escalafon: '',
                vinculacion: '',
                cargaHorariaHora: '',
                cargaHorariaMinuto: '',
                desde: '',
                hasta: '',
                codigoRelLaboral: '',
                codigoForPago: '',
                serieConcurso: '',
            },

            datosObtenidos: {},
            datosCambios: [],
            consultaDatos: {},
        })
    }

    async actualizarLista(e){
        this.setState({
            errores: null,
            loading: true,
        })
        const cargaUtil = JSON.stringify(this.state.busqueda);
        const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_NumFun.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        //Consulto sobre los movimientos que ya tuvo
        const cargaUtil2 = JSON.stringify([this.state.busqueda]);
        const res = await fetch(`${Constantes.RUTA_API}/consultar_cambiosCargos.php`,{
            method: 'POST',
            body: cargaUtil2,
        })
        const exito2 = await res.json();
        //------------------------------------------
        if(exito){
            if(exito.length === 0){
                this.setState({
                    errores: 'NO EXISTEN DATOS PARA EL NUMERO DE FUNCIONARIO INGRESADO',
                    loading: false,
                    notificaciones: null,
                });
            }else{
                this.setState({
                    datosObtenidos: exito[0],
                    datosCambios: exito2[1],
                    loading: false,
                    consulta: true,
                });
                this.actualizarDatos();
            }
        }
    }

    async manejarBorrar(dato){
        this.setState({
            errores: null,
            loading: true,
        })
        const cargaUtil = JSON.stringify([dato]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_cambioCargo.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
        })

        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Los datos fueron eliminados',
                loading: false,
            })
            this.actualizarLista();
        }
    }

    manejarCambiosDatosFinalizar(e){
        e.preventDefault();
        let valor = e.target.value;

        this.setState({
            errores: null,
            notificaciones: null,
            hastaFinalizar: valor,
        })
    }

    cerrarModal(e){
        this.setState({
            modalFinalizar: false,
            consultaDatos: {},
        })
    }

    async manejarEnvioFinalizar(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
        })
        if(this.state.hastaFinalizar === ''){
            this.setState({
                errores: 'Debe ingresar la fecha de finalización',
                notificaciones: null,
            })
        }else{
            this.setState({
                errores: null,
                loading: true,
                modalFinalizar: false,
            })
            const cargaUtil = JSON.stringify([this.state.consultaDatos, this.state.hastaFinalizar]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/finalizar_cambioCargo.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                loading: false,
                errores: exito[0],
            })

            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: 'Finalizado correctamente',
                })
            }
            this.actualizarLista();
        }
    }
}

export default CambiosFuncionario